import { Formik } from 'formik';
import type { Dispatch, SetStateAction } from 'react';
import type { CloudUploadScope } from 'api/apiCloudflare';
import { useProduct } from '../context/ProductProvider';
import type { ProductEditType } from '../types';
import useSaveProductCard from './model/useSaveProductCard';
import ProductForm from './ProductForm';

interface ProductFormikProps {
    product: ProductEditType;
    fetchProducts: (force?: boolean) => Promise<unknown>;
    setProduct: Dispatch<SetStateAction<ProductEditType | null>>;
}

const ProductFormik = ({ product, fetchProducts, setProduct }: ProductFormikProps) => {
    const { setShowEditProduct } = useProduct();
    const { saveProductCard } = useSaveProductCard({
        fetchProducts,
        setProduct,
        setShowEditProduct,
    });

    return (
        <Formik
            initialValues={{
                ...product,
            }}
            onSubmit={async (values, { setSubmitting }) => {
                await saveProductCard(values, {
                    entityId: Number(product.ID || values.ID || 0),
                    close: true,
                });
                setSubmitting(false);
            }}
        >
            {({ handleSubmit, isSubmitting, setFieldValue, values }) => {
                const ensureSaved = async (): Promise<CloudUploadScope | false> => {
                    const result = await saveProductCard(values as ProductEditType, {
                        entityId: Number(product.ID || values.ID || 0),
                        close: false,
                    });
                    if (!result.ok) return false;

                    setFieldValue('ID', result.entityId);
                    setFieldValue('prodArticle', result.values.prodArticle);
                    setFieldValue('prodName', result.values.prodName);
                    setFieldValue('vendorId', result.values.vendorId);
                    setFieldValue('dimensionId', result.values.dimensionId);
                    return { productId: result.entityId };
                };

                return (
                    <ProductForm
                        product={product}
                        handleSubmit={handleSubmit}
                        isSubmitting={isSubmitting}
                        setFieldValue={setFieldValue}
                        values={values as ProductEditType}
                        ensureSaved={ensureSaved}
                        fetchProducts={fetchProducts}
                    />
                );
            }}
        </Formik>
    );
};

export default ProductFormik;
